import ItemComentario from './ItemComentario'
import enhancer from './ItemComentario.enhancer'

export default enhancer(ItemComentario)


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Comentarios/components/ItemComentario/index.js